var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircledCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5004 21.0227C6.15945 21.0227 1.84126 16.7045 1.84126 11.3636C1.84126 6.02273 6.15945 1.70455 11.5004 1.70455C16.8413 1.70455 21.1594 6.02273 21.1594 11.3636C21.1594 16.7045 16.8413 21.0227 11.5004 21.0227ZM11.5004 0C5.25036 0 0.136719 5.11364 0.136719 11.3636C0.136719 17.6136 5.25036 22.7273 11.5004 22.7273C17.7504 22.7273 22.864 17.6136 22.864 11.3636C22.864 5.11364 17.7504 0 11.5004 0Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7954 7.38623L10.3635 12.9544L7.97718 11.0226L6.84082 12.2726L9.22716 14.2044L10.5907 15.3408L11.7271 13.9771H11.6135L16.1589 8.52259L14.7954 7.38623Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCheck);
export default __webpack_public_path__ + "static/media/circled-check.5786078a9a70b862cb1dca2d45cd3075.svg";
export { ForwardRef as ReactComponent };